module.exports = __webpack_public_path__ + "media/images/flags/bz-93a215cd4bea4a40059c7cabdd046514.svg";